import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import {withRouter} from "react-router-dom";
import {apiCall} from "../../helpers/MainHelper";
import withPermissions from "../WithPermissions";

class StockTransfersTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
    }

    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };

    handleTransferDetail = (transferId) => {
        this.props.history.push(`/stock/transfer-detail/${transferId}`);
    }

    getStatusLabel = (status) => {
        const statuses = {
            'pending': 'Beklemede',
            'approved': 'Onaylandı',
            'in_transit': 'Yolda',
            'completed': 'Tamamlandı',
            'cancelled': 'İptal Edildi'
        };
        return statuses[status] || status;
    }

    getStatusBadge = (status) => {
        const badges = {
            'pending': 'badge-warning',
            'approved': 'badge-info',
            'in_transit': 'badge-primary',
            'completed': 'badge-success',
            'cancelled': 'badge-danger'
        };
        return badges[status] || 'badge-secondary';
    }

    render() {
        const {userPermissions} = this.props;
        const userHasViewPermission = userPermissions.includes('stock.view');

        const columns = [
            {
                name:'Transfer No',
                selector:row => row.transfer_number,
                sortable:true,
                minWidth: '140px',
                maxWidth: '160px',
                cell: row => (
                    <div style={{fontWeight: '600', color: '#495057', padding: '12px 8px'}}>
                        {row.transfer_number}
                    </div>
                )
            },
            {
                name:'Kaynak Depo',
                selector:row => row.from_warehouse ? row.from_warehouse.name : '-',
                sortable:true,
                grow: 1,
                wrap: true,
                style: {
                    padding: '12px 8px'
                }
            },
            {
                name:'Hedef Depo',
                selector:row => row.to_warehouse ? row.to_warehouse.name : '-',
                sortable:true,
                grow: 1,
                wrap: true,
                style: {
                    padding: '12px 8px'
                }
            },
            {
                name:'Talep Eden',
                selector:row => row.requested_by ? `${row.requested_by.name} ${row.requested_by.surname || ''}`.trim() : '-',
                sortable:true,
                grow: 0.8,
                wrap: true,
                style: {
                    padding: '12px 8px'
                }
            },
            {
                name:'Onaylayan',
                selector:row => row.approved_by ? `${row.approved_by.name} ${row.approved_by.surname || ''}`.trim() : '-',
                sortable:true,
                grow: 0.8,
                wrap: true,
                cell: row => (
                    <div style={{color: row.approved_by ? '#28a745' : '#6c757d', padding: '12px 8px'}}>
                        {row.approved_by ? `${row.approved_by.name} ${row.approved_by.surname || ''}`.trim() : '-'}
                    </div>
                )
            },
            {
                name:'Transfer Tarihi',
                selector:row => row.transfer_date ? new Date(row.transfer_date).toLocaleDateString('tr-TR') : '-',
                sortable:true,
                minWidth: '130px',
                maxWidth: '150px',
                center: true,
                style: {
                    padding: '12px 8px'
                }
            },
            {
                name:'Durum',
                cell: row => (
                    <span className={`badge ${this.getStatusBadge(row.status)}`} style={{
                        fontSize: '12px',
                        padding: '8px 14px',
                        fontWeight: '600',
                        minWidth: '100px',
                        textAlign: 'center',
                        display: 'inline-block'
                    }}>
                        {this.getStatusLabel(row.status)}
                    </span>
                ),
                sortable:true,
                minWidth: '140px',
                maxWidth: '160px',
                center: true,
                style: {
                    padding: '12px 8px'
                }
            },

        ];

        return (
            <DataTable
                ref={this.tableRef}
                columns={columns}
                onRowClicked={userHasViewPermission ? row => this.handleTransferDetail(row.id) : undefined}
                dataEndpoint="business/stock/transfer/all"
            />
        );
    }
}

export default withPermissions(withRouter(StockTransfersTable));
